let myToken = null;
const KEY = 'wstkn'

export const getToken = () => {
  if (!myToken) {
    myToken = localStorage.getItem(KEY) || null;
  }
  return myToken;
};

export const setToken = token => {
  localStorage.setItem(KEY, token);
  myToken = token;
};

export const clearToken = () => {
  localStorage.removeItem(KEY);
  myToken = null;
};

export const clearStateByKey = (key) => {
  localStorage.removeItem(key);
};

export const saveQueryToStorage = () => {
  const location = window.location
  const path = location.pathname.replace('/', '') || '/'
  const utm = location.search.replace(/^[?]/, '') || ''

  localStorage.setItem('query', JSON.stringify({
    path: path,
    utm: utm
  }))
}



// WEBPACK FOOTER //
// ./src/utils/tokenStorage.js